import axios from "axios";
import { apiUrl } from "../constant";
/* istanbul ignore next */
export const getAllNotificationsService = () => {
    return axios.get(`${apiUrl}/api/IncomingPackage/GetExportedFilesList?exportCsvModules=2`);
};